// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

export enum CtsGantryEventFilterTabEType {
  ALL_EVENTS = 'allEvents',
  ERRORS = 'errors',
}
